import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_2 = { class: "flex justify-between items-center py-10" }
const _hoisted_3 = { class: "text-3xl" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "flex justify-between items-center py-10 gap-4" }
const _hoisted_6 = { class: "text-3xl font-bold" }
const _hoisted_7 = { class: "grow grid grid-cols-2 items-center" }
const _hoisted_8 = { class: "flex flex-col grow" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "flex items-end rotate-x-180 overflow-x-scroll min-h-[250px]" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "border border-next-neu rounded text-center text-xs" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex justify-end" }
const _hoisted_16 = { class: "flex items-end rotate-x-180 overflow-x-scroll min-h-[250px]" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "border border-next-neu rounded text-center text-xs" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "flex justify-end" }
const _hoisted_24 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ConfermaModal = _resolveComponent("ConfermaModal")!
  const _component_CercaModal = _resolveComponent("CercaModal")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_HomeAlertBar = _resolveComponent("HomeAlertBar")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_LegendaStatiCliente = _resolveComponent("LegendaStatiCliente")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TableTooltip = _resolveComponent("TableTooltip")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
      (_ctx.confirmDelete)
        ? (_openBlock(), _createBlock(_component_ConfermaModal, {
            key: 0,
            backdrop: false,
            visible: _ctx.confirmDelete,
            onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmDelete = false)),
            onConfirm: _ctx.performDelete
          }, null, 8, ["visible", "onConfirm"]))
        : _createCommentVNode("", true),
      (_ctx.cercaModalVisibility)
        ? (_openBlock(), _createBlock(_component_CercaModal, {
            key: 1,
            back: "",
            onReject: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cercaModalVisibility = false)),
            onConfirm: _ctx.cerca
          }, null, 8, ["onConfirm"]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cm_visible = -1)),
      class: "m-auto px-8 md:px-20"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.labelGender) + " ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.me.name), 1)
          ]),
          (_ctx.hasPermission('create aziende') && _ctx.rubrica === 0)
            ? (_openBlock(), _createBlock(_component_NextButton, {
                key: 0,
                component: "router-link",
                to: {name: 'NuovoCliente'},
                variant: "primary",
                class: "w-44 ml-3 text-sm py-2 px-4 m-0"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" + Aggiungi ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_HomeAlertBar, {
          ok: _ctx.meCounters.ok,
          scaduti: _ctx.meCounters.scaduti,
          in_scadenza: _ctx.meCounters.in_scadenza,
          contatti: _ctx.meCounters.contatti,
          clienti: _ctx.meCounters.clienti
        }, null, 8, ["ok", "scaduti", "in_scadenza", "contatti", "clienti"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(["I miei clienti", "I miei contatti", 'Tutti i clienti', 'Tutti i contatti'][_ctx.rubrica]), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Field, {
                labelVisible: false,
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                placeholder: "Cerca"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cercaModalVisibility = !_ctx.cercaModalVisibility)),
                class: "pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"
              })
            ])
          ]),
          _createVNode(_component_Switcher, {
            modelValue: _ctx.rubrica,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rubrica) = $event)),
            options: _ctx.getSwitchOptions
          }, null, 8, ["modelValue", "options"])
        ]),
        (_ctx.rubrica===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_LegendaStatiCliente),
                _createVNode(_component_Paginator, {
                  pagination: _ctx.listaMyClienti.paginate
                }, null, 8, ["pagination"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed",
                  cols: _ctx.clientiCols,
                  rows: _ctx.listaMyClienti.rows,
                  onOrderUpdate: _ctx.listaMyClienti.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaMyClienti.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioAzienda', params:{id:context.context.row.id}},
                          class: "block text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyClienti.rows, (c, j) => {
                    return {
                      name: `td_${j}_0`,
                      fn: _withCtx(({context}) => [
                        _createVNode(_component_TableTooltip, {
                          inner_class: context.cell.td_class
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                          ]),
                          _: 2
                        }, 1032, ["inner_class"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyClienti.rows, (c, j) => {
                    return {
                      name: `td_${j}_1`,
                      fn: _withCtx(({context}) => [
                        _createVNode(_component_TableTooltip, {
                          inner_class: context.cell.td_class
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                          ]),
                          _: 2
                        }, 1032, ["inner_class"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyClienti.rows, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_TabellaContextMenu, {
                          menuClass: "shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                          buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                          context: c,
                          id: j,
                          teleport_to: "#modal",
                          cmOpener: _ctx.cmOpener
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {name:'Attivita', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("Attività ")
                              ])),
                              _: 2
                            }, 1032, ["to"]),
                            _createVNode(_component_router_link, {
                              to: {name:'Contatti', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode("Contatti ")
                              ])),
                              _: 2
                            }, 1032, ["to"]),
                            (_ctx.isNewBusiness)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.cancellaAzienda(c.id)),
                                  class: "text-next-orange"
                                }, "Elimina", 8, _hoisted_12))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["context", "id", "cmOpener"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyClienti.rows, (c, j) => {
                    return {
                      name: `td_${j}_3`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.ultimo_contatto)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyClienti.rows, (c, j) => {
                    return {
                      name: `td_${j}_2`,
                      fn: _withCtx(({context}) => [
                        _createElementVNode("div", {
                          class: "grid gap-1",
                          style: _normalizeStyle({'grid-template-columns': `repeat(${_ctx.businessUnits.length}, minmax(0, 1fr))`})
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "tooltip-activator relative cursor-pointer",
                              key: bu.id
                            }, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(bu.label), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass([`bg-next-${_ctx.getColoriStati(context.row.stati[bu.id])}`, "border rounded text-center text-xs text-white"])
                              }, _toDisplayString(_ctx.getLabel(context.row.stati[bu.id])), 3),
                              _createVNode(_component_Tooltip, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getTooltip(context.row.stati[bu.id])), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ], 4)
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaMyClienti.fetchNextPage,
                identifier: _ctx.listaMyClienti.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_ctx.rubrica===1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Paginator, {
                    pagination: _ctx.listaMyContatti.paginate
                  }, null, 8, ["pagination"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_NextTable, {
                    class: "rotate-x-180 w-full border-separate border-spacing-3 py-4",
                    cols: _ctx.contattiCols,
                    "onUpdate:cols": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contattiCols) = $event)),
                    rows: _ctx.listaMyContatti.rows,
                    onOrderUpdate: _ctx.listaMyContatti.updateCols
                  }, _createSlots({ _: 2 }, [
                    _renderList(_ctx.listaMyContatti.rows, (c, j) => {
                      return {
                        name: `td_${j}_7`,
                        fn: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: {name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}},
                            class: "text-center inset-0 absolute flex items-center justify-center"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      }
                    })
                  ]), 1032, ["cols", "rows", "onOrderUpdate"])
                ]),
                _createVNode(_component_InfiniteLoading, {
                  onInfinite: _ctx.listaMyContatti.fetchNextPage,
                  identifier: _ctx.listaMyContatti.infiniteIdentifier,
                  style: {"min-height":"1px"}
                }, {
                  complete: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri contatti.", -1)
                  ])),
                  _: 1
                }, 8, ["onInfinite", "identifier"])
              ]))
            : (_ctx.rubrica===2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_LegendaStatiCliente),
                    _createVNode(_component_Paginator, {
                      pagination: _ctx.listaClienti.paginate
                    }, null, 8, ["pagination"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_NextTable, {
                      class: "rotate-x-180 table-fixed w-full border-separate border-spacing-3 py-4",
                      cols: _ctx.clientiCols,
                      "onUpdate:cols": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clientiCols) = $event)),
                      pagination: _ctx.listaClienti.paginate,
                      rows: _ctx.listaClienti.rows,
                      onOrderUpdate: _ctx.listaClienti.updateCols
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.listaClienti.rows, (c, j) => {
                        return {
                          name: `td_${j}_0`,
                          fn: _withCtx(({context}) => [
                            _createVNode(_component_TableTooltip, {
                              inner_class: context.cell.td_class
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                              ]),
                              _: 2
                            }, 1032, ["inner_class"])
                          ])
                        }
                      }),
                      _renderList(_ctx.listaClienti.rows, (c, j) => {
                        return {
                          name: `td_${j}_1`,
                          fn: _withCtx(({context}) => [
                            _createVNode(_component_TableTooltip, {
                              inner_class: context.cell.td_class
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                              ]),
                              _: 2
                            }, 1032, ["inner_class"])
                          ])
                        }
                      }),
                      _renderList(_ctx.listaClienti.rows, (c, j) => {
                        return {
                          name: `td_${j}_4`,
                          fn: _withCtx((context) => [
                            _createVNode(_component_router_link, {
                              to: {name:'DettaglioAzienda', params:{id:context.context.row.id}},
                              class: "text-center inset-0 absolute flex items-center justify-center"
                            }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        }
                      }),
                      _renderList(_ctx.listaClienti.rows, (c, j) => {
                        return {
                          name: `td_${j}_5`,
                          fn: _withCtx(() => [
                            _createVNode(_component_TabellaContextMenu, {
                              menuClass: "shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                              buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                              context: c,
                              id: j,
                              teleport_to: "#modal",
                              cmOpener: _ctx.cmOpener
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: {name:'Attivita', params: {id:c.id}},
                                  class: "hover:text-next-neu mb-2"
                                }, {
                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createTextVNode("Attività ")
                                  ])),
                                  _: 2
                                }, 1032, ["to"]),
                                _createVNode(_component_router_link, {
                                  to: {name:'Contatti', params: {id:c.id}},
                                  class: "hover:text-next-neu mb-2"
                                }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("Contatti ")
                                  ])),
                                  _: 2
                                }, 1032, ["to"]),
                                (_ctx.isNewBusiness)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.cancellaAzienda(c.id)),
                                      class: "text-next-orange"
                                    }, "Elimina", 8, _hoisted_20))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["context", "id", "cmOpener"])
                          ])
                        }
                      }),
                      _renderList(_ctx.listaClienti.rows, (c, j) => {
                        return {
                          name: `td_${j}_3`,
                          fn: _withCtx((context) => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.ultimo_contatto)), 1)
                          ])
                        }
                      }),
                      _renderList(_ctx.listaClienti.rows, (c, j) => {
                        return {
                          name: `td_${j}_2`,
                          fn: _withCtx(({context}) => [
                            _createElementVNode("div", {
                              class: "grid gap-1",
                              style: _normalizeStyle({'grid-template-columns': `repeat(${_ctx.businessUnits.length}, minmax(0, 1fr))`})
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "tooltip-activator relative cursor-pointer",
                                  key: bu.id
                                }, [
                                  _createElementVNode("div", _hoisted_21, _toDisplayString(bu.label), 1),
                                  _createElementVNode("div", {
                                    class: _normalizeClass([`bg-next-${_ctx.getColoriStati(context.row.stati[bu.id])}`, "border rounded text-center text-xs text-white"])
                                  }, _toDisplayString(_ctx.getLabel(context.row.stati[bu.id])), 3),
                                  _createVNode(_component_Tooltip, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getTooltip(context.row.stati[bu.id])), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              }), 128))
                            ], 4)
                          ])
                        }
                      })
                    ]), 1032, ["cols", "pagination", "rows", "onOrderUpdate"])
                  ]),
                  _createVNode(_component_InfiniteLoading, {
                    onInfinite: _ctx.listaClienti.fetchNextPage,
                    identifier: _ctx.listaClienti.infiniteIdentifier,
                    style: {"min-height":"1px"}
                  }, {
                    complete: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                    ])),
                    _: 1
                  }, 8, ["onInfinite", "identifier"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_Paginator, {
                      pagination: _ctx.listaContatti.paginate
                    }, null, 8, ["pagination"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_NextTable, {
                      class: "rotate-x-180 w-full border-separate border-spacing-3 py-4",
                      cols: _ctx.contattiCols,
                      "onUpdate:cols": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contattiCols) = $event)),
                      rows: _ctx.listaContatti.rows,
                      onOrderUpdate: _ctx.listaContatti.updateCols
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.listaContatti.rows, (c, j) => {
                        return {
                          name: `td_${j}_7`,
                          fn: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}},
                              class: "text-center inset-0 absolute flex items-center justify-center"
                            }, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        }
                      })
                    ]), 1032, ["cols", "rows", "onOrderUpdate"])
                  ]),
                  _createVNode(_component_InfiniteLoading, {
                    onInfinite: _ctx.listaContatti.fetchNextPage,
                    identifier: _ctx.listaContatti.infiniteIdentifier,
                    style: {"min-height":"1px"}
                  }, {
                    complete: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri contatti.", -1)
                    ])),
                    _: 1
                  }, 8, ["onInfinite", "identifier"])
                ]))
      ])
    ])
  ], 64))
}